import 'globals';

(function(window, document, pageLoadedQueue) {
    pageLoadedQueue.push(function() {
        // Show or hide different address by checkbox selection
        var checkboxes = document.querySelectorAll('[name="--checkoutForm_billingAddress[billingAddress_selection]"], [name="--checkoutForm_shippingAddress[shippingAddress_selection]"]'),
            wrapper = document.querySelector('#checkoutForm_billingAddress-wrapper, #checkoutForm_shippingAddress-wrapper');

        Array.prototype.forEach.call(checkboxes, function(el) {
            if (el.checked && (el.value === 'differentBillingAddress' || el.value === 'differentShippingAddress'))  {
                wrapper.classList.remove('d-none');
            }

            el.addEventListener('change', function() {
                if (el.value === 'differentBillingAddress' || el.value === 'differentShippingAddress')  {
                    wrapper.classList.remove('d-none');
                } else {
                    wrapper.classList.add('d-none');
                }
            }, false);
        });
    });
})(window, document, window.pageLoadedQueue);
